import React, { useEffect, useState } from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import { Flex, Footer, Title, Subtitle, ModalContent } from './styled';
import CancelButton from 'shared/ui/CancelButton';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import { MODAL_EMAIL_VERIFICATION_MESSAGE } from 'store/modals/modals';
import { selectEmailToVerify } from 'store/Settings/settingsSelectors';

const ModalEmailVerificationMessage = ({ closeAccountModal }) => {
  const dispatch = useDispatch();
  const email = useSelector(selectEmailToVerify);
  const [localEmail, setLocalEmail] = useState(email);
  const description = `Check your inbox at ${localEmail}. We sent your verification link to complete the change.`;

  const close = () => {
    dispatch(closeModal(MODAL_EMAIL_VERIFICATION_MESSAGE));
  };

  useEffect(() => {
    if (email) {
      setLocalEmail(email);
    }
  }, [email]);

  return (
    <ModalWrapper>
        <ModalContent>
            <Flex>
                <Title>Email Configuration</Title>
            </Flex>
            <Subtitle>{description}</Subtitle>
            <Footer>
                <CancelButton onClick={ close } />
            </Footer>
        </ModalContent>
    </ModalWrapper>
  );
};

export default ModalEmailVerificationMessage;
